/* ============================================================
   DS LIGHTBOX — Zoom, Pan, Pinch, Download, Swipe
   Add this to ds-product.js or load as ds-lightbox.js (defer)
   ============================================================ */

(function () {
  'use strict';

  // ─── State ───────────────────────────────────────────────────────────────────
  let images      = [];   // [{src, srcset, alt, thumb}]
  let currentIdx  = 0;
  let scale       = 1;
  let minScale    = 1;
  let maxScale    = 5;
  let panX        = 0;
  let panY        = 0;
  let isDragging  = false;
  let dragStartX  = 0;
  let dragStartY  = 0;
  let lastPanX    = 0;
  let lastPanY    = 0;
  let lastScale   = 1;
  let swipeStartX = 0;
  let swipeStartY = 0;
  let swipeDist   = 0;
  let isSwipe     = false;
  let touchStartDist = 0;
  let touchMidX   = 0;
  let touchMidY   = 0;
  let toastTimer  = null;
  let hintShown   = false;
  let lb          = null; // lightbox DOM root

  // ─── Build lightbox DOM once ──────────────────────────────────────────────────
  function buildLightbox() {
    if (document.getElementById('ds-lightbox')) return;

    const el = document.createElement('div');
    el.id = 'ds-lightbox';
    el.className = 'ds-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');

    el.innerHTML = `
      <div class="ds-lightbox__stage" id="ds-lb-stage">
        <div class="ds-lightbox__img-wrap" id="ds-lb-img-wrap">
          <img class="ds-lightbox__img" id="ds-lb-img" alt="" draggable="false">
        </div>
        <div class="ds-lightbox__spinner" id="ds-lb-spinner"></div>
        <div class="ds-lightbox__slide-toast" id="ds-lb-toast"></div>
        <div class="ds-lightbox__swipe-hint" id="ds-lb-swipe-hint">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M14 7l5 5-5 5"/></svg>
          Swipe to navigate
        </div>
      </div>

      <div class="ds-lightbox__bar">
        <div class="ds-lightbox__counter" id="ds-lb-counter">1 / 1</div>
        <div class="ds-lightbox__bar-actions">
          <button class="ds-lightbox__btn ds-lightbox__btn--download" id="ds-lb-download" title="Download image" aria-label="Download image">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 3v13M5 14l7 7 7-7"/><path d="M3 21h18"/></svg>
            <span class="ds-lb-dl-label">Download</span>
          </button>
          <button class="ds-lightbox__btn" id="ds-lb-close" title="Close (Esc)" aria-label="Close lightbox">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
      </div>

      <button class="ds-lightbox__nav ds-lightbox__nav--prev ds-lightbox__btn" id="ds-lb-prev" aria-label="Previous image">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <button class="ds-lightbox__nav ds-lightbox__nav--next ds-lightbox__btn" id="ds-lb-next" aria-label="Next image">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 18l6-6-6-6"/></svg>
      </button>

      <div class="ds-lightbox__thumbstrip" id="ds-lb-thumbstrip"></div>

      <div class="ds-lightbox__zoom-bar">
        <button class="ds-lightbox__btn" id="ds-lb-zoom-out" aria-label="Zoom out">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M8 11h6"/></svg>
        </button>
        <span class="ds-lightbox__zoom-level" id="ds-lb-zoom-level">1×</span>
        <button class="ds-lightbox__btn" id="ds-lb-zoom-in" aria-label="Zoom in">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/></svg>
        </button>
        <button class="ds-lightbox__btn" id="ds-lb-zoom-reset" aria-label="Reset zoom" title="Reset">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
        </button>
      </div>
    `;

    document.body.appendChild(el);
    lb = el;

    // Cache refs
    const stage    = document.getElementById('ds-lb-stage');
    const imgWrap  = document.getElementById('ds-lb-img-wrap');
    const img      = document.getElementById('ds-lb-img');
    const counter  = document.getElementById('ds-lb-counter');
    const zoomLvl  = document.getElementById('ds-lb-zoom-level');
    const spinner  = document.getElementById('ds-lb-spinner');
    const toast    = document.getElementById('ds-lb-toast');
    const hint     = document.getElementById('ds-lb-swipe-hint');
    const thumbstrip = document.getElementById('ds-lb-thumbstrip');

    // ─── Open / Close ────────────────────────────────────────────────────────────
    window.dsLightboxOpen = function (idx) {
      currentIdx = idx || 0;
      lb.classList.add('is-open');
      if (images.length <= 1) lb.classList.add('ds-lightbox--single');
      else lb.classList.remove('ds-lightbox--single');
      document.body.style.overflow = 'hidden';
      buildThumbs();
      loadImage(currentIdx, false);
      if (!hintShown && images.length > 1 && 'ontouchstart' in window) {
        setTimeout(() => {
          hint.classList.add('is-visible');
          setTimeout(() => hint.classList.remove('is-visible'), 2800);
        }, 600);
        hintShown = true;
      }
    };

    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      resetZoom(false);
    }

    // ─── Load image ──────────────────────────────────────────────────────────────
    function loadImage(idx, showToast) {
      const data = images[idx];
      if (!data) return;

      resetZoom(false);
      spinner.classList.add('is-visible');

      img.onload = () => {
        spinner.classList.remove('is-visible');
        imgWrap.classList.add('is-animating');
        setTimeout(() => imgWrap.classList.remove('is-animating'), 260);
      };
      img.onerror = () => spinner.classList.remove('is-visible');
      img.src = data.src;
      if (data.srcset) img.srcset = data.srcset;
      img.alt = data.alt || '';

      counter.textContent = `${idx + 1} / ${images.length}`;
      updateZoomUI();
      updateThumbsActive(idx);

      if (showToast) {
        toast.textContent = `${idx + 1} / ${images.length}`;
        toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 900);
      }
    }

    // ─── Thumbnails ───────────────────────────────────────────────────────────────
    function buildThumbs() {
      thumbstrip.innerHTML = '';
      if (images.length <= 1) { thumbstrip.style.display = 'none'; return; }
      thumbstrip.style.display = '';
      images.forEach((data, i) => {
        const t = document.createElement('img');
        t.className = 'ds-lightbox__lb-thumb' + (i === currentIdx ? ' is-active' : '');
        t.src = data.thumb || data.src;
        t.alt = '';
        t.loading = 'lazy';
        t.addEventListener('click', () => navigate(i));
        thumbstrip.appendChild(t);
      });
    }

    function updateThumbsActive(idx) {
      thumbstrip.querySelectorAll('.ds-lightbox__lb-thumb').forEach((t, i) => {
        t.classList.toggle('is-active', i === idx);
      });
      const activeThumb = thumbstrip.children[idx];
      if (activeThumb) activeThumb.scrollIntoView({ inline: 'center', behavior: 'smooth' });
    }

    // ─── Navigate ─────────────────────────────────────────────────────────────────
    function navigate(idx) {
      if (idx < 0) idx = images.length - 1;
      if (idx >= images.length) idx = 0;
      currentIdx = idx;
      loadImage(currentIdx, true);
    }

    document.getElementById('ds-lb-prev').addEventListener('click', () => navigate(currentIdx - 1));
    document.getElementById('ds-lb-next').addEventListener('click', () => navigate(currentIdx + 1));
    document.getElementById('ds-lb-close').addEventListener('click', closeLightbox);

    // Click on backdrop (stage) to close if not zoomed and not dragged
    let stageClickCancelled = false;
    stage.addEventListener('mousedown', () => { stageClickCancelled = false; });
    stage.addEventListener('mousemove', () => { if (isDragging) stageClickCancelled = true; });
    stage.addEventListener('click', (e) => {
      if (stageClickCancelled) return;
      if (e.target === stage) closeLightbox();
    });

    // Keyboard
    document.addEventListener('keydown', onKeyDown);

    // ─── Zoom controls ────────────────────────────────────────────────────────────
    document.getElementById('ds-lb-zoom-in').addEventListener('click', () => zoomBy(0.5));
    document.getElementById('ds-lb-zoom-out').addEventListener('click', () => zoomBy(-0.5));
    document.getElementById('ds-lb-zoom-reset').addEventListener('click', () => resetZoom(true));

    // Mouse wheel zoom
    stage.addEventListener('wheel', (e) => {
      if (!lb.classList.contains('is-open')) return;
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.25 : 0.25;
      zoomAt(scale + delta, e.clientX, e.clientY);
    }, { passive: false });

    // Double-click to zoom in/out
    stage.addEventListener('dblclick', (e) => {
      if (scale > 1.2) {
        resetZoom(true);
      } else {
        zoomAt(2.5, e.clientX, e.clientY);
      }
    });

    // ─── Mouse drag ───────────────────────────────────────────────────────────────
    stage.addEventListener('mousedown', (e) => {
      if (scale <= 1) return;
      isDragging = true;
      dragStartX = e.clientX - panX;
      dragStartY = e.clientY - panY;
      stage.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      panX = e.clientX - dragStartX;
      panY = e.clientY - dragStartY;
      clampPan();
      applyTransform(false);
    });

    window.addEventListener('mouseup', () => {
      isDragging = false;
      stage.classList.remove('is-dragging');
    });

    // ─── Touch: pinch-to-zoom + swipe + drag ─────────────────────────────────────
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd, { passive: false });

    function onTouchStart(e) {
      if (e.touches.length === 1) {
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swipeDist = 0;
        isSwipe = false;
        if (scale > 1) {
          isDragging = true;
          dragStartX = e.touches[0].clientX - panX;
          dragStartY = e.touches[0].clientY - panY;
        }
      } else if (e.touches.length === 2) {
        isDragging = false;
        const t = e.touches;
        touchStartDist = Math.hypot(t[1].clientX - t[0].clientX, t[1].clientY - t[0].clientY);
        touchMidX = (t[0].clientX + t[1].clientX) / 2;
        touchMidY = (t[0].clientY + t[1].clientY) / 2;
        lastScale = scale;
        e.preventDefault();
      }
    }

    function onTouchMove(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const t = e.touches;
        const dist = Math.hypot(t[1].clientX - t[0].clientX, t[1].clientY - t[0].clientY);
        const newScale = lastScale * (dist / touchStartDist);
        zoomAt(newScale, touchMidX, touchMidY);
      } else if (e.touches.length === 1) {
        const dx = e.touches[0].clientX - swipeStartX;
        const dy = e.touches[0].clientY - swipeStartY;
        swipeDist = dx;

        if (scale > 1 && isDragging) {
          e.preventDefault();
          panX = e.touches[0].clientX - dragStartX;
          panY = e.touches[0].clientY - dragStartY;
          clampPan();
          applyTransform(false);
          return;
        }

        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          isSwipe = true;
          e.preventDefault();
        }
      }
    }

    function onTouchEnd(e) {
      isDragging = false;
      if (isSwipe && images.length > 1 && scale <= 1) {
        if (swipeDist < -60) navigate(currentIdx + 1);
        else if (swipeDist > 60) navigate(currentIdx - 1);
      }
      isSwipe = false;
    }

    // ─── Zoom helpers ─────────────────────────────────────────────────────────────
    function zoomBy(delta) {
      const cx = window.innerWidth / 2;
      const cy = window.innerHeight / 2;
      zoomAt(scale + delta, cx, cy);
    }

    function zoomAt(newScale, originX, originY) {
      newScale = Math.min(maxScale, Math.max(minScale, newScale));
      if (newScale === scale) return;

      // Adjust pan so zoom is centered on cursor/pinch
      const ratio = newScale / scale;
      const stageRect = stage.getBoundingClientRect();
      const relX = originX - stageRect.left - stageRect.width / 2;
      const relY = originY - stageRect.top - stageRect.height / 2;
      panX = relX - ratio * (relX - panX);
      panY = relY - ratio * (relY - panY);

      scale = newScale;
      clampPan();
      applyTransform(true);
      updateZoomUI();
    }

    function resetZoom(animate) {
      scale = 1;
      panX = 0;
      panY = 0;
      applyTransform(animate);
      updateZoomUI();
    }

    function clampPan() {
      if (scale <= 1) { panX = 0; panY = 0; return; }
      const stageW = stage.offsetWidth;
      const stageH = stage.offsetHeight;
      const imgW   = img.offsetWidth;
      const imgH   = img.offsetHeight;
      const maxX   = Math.max(0, (imgW * scale - stageW) / 2);
      const maxY   = Math.max(0, (imgH * scale - stageH) / 2);
      panX = Math.min(maxX, Math.max(-maxX, panX));
      panY = Math.min(maxY, Math.max(-maxY, panY));
    }

    function applyTransform(animate) {
      if (animate) {
        imgWrap.classList.add('is-animating');
        setTimeout(() => imgWrap.classList.remove('is-animating'), 260);
      }
      imgWrap.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
    }

    function updateZoomUI() {
      const pct = Math.round(scale * 100);
      const lvl = document.getElementById('ds-lb-zoom-level');
      if (lvl) lvl.textContent = scale === 1 ? '1×' : `${pct}%`;
    }

    // ─── Download ────────────────────────────────────────────────────────────────
    document.getElementById('ds-lb-download').addEventListener('click', () => {
      const data = images[currentIdx];
      if (!data) return;
      // Fetch highest-res src and trigger download
      const src = data.fullSrc || data.src;
      const btn = document.getElementById('ds-lb-download');
      const origHTML = btn.innerHTML;

      // Show brief loading state
      btn.innerHTML = `
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" style="animation:ds-lb-spin 0.7s linear infinite"><circle cx="12" cy="12" r="9" stroke-opacity="0.3"/><path d="M12 3a9 9 0 0 1 9 9"/></svg>
        <span class="ds-lb-dl-label">Saving…</span>
      `;

      fetch(src, { mode: 'cors' })
        .then(r => r.blob())
        .then(blob => {
          const ext  = blob.type.split('/')[1] || 'jpg';
          const name = (data.alt || 'image').replace(/[^a-z0-9]/gi, '-').replace(/-+/g, '-').toLowerCase() + '.' + ext;
          const url  = URL.createObjectURL(blob);
          const a    = document.createElement('a');
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 500);
          btn.innerHTML = origHTML;
        })
        .catch(() => {
          // Fallback: open in new tab if CORS blocked
          window.open(src, '_blank');
          btn.innerHTML = origHTML;
        });
    });

    // ─── Keyboard ────────────────────────────────────────────────────────────────
    function onKeyDown(e) {
      if (!lb.classList.contains('is-open')) return;
      switch (e.key) {
        case 'Escape':    closeLightbox(); break;
        case 'ArrowLeft': navigate(currentIdx - 1); break;
        case 'ArrowRight':navigate(currentIdx + 1); break;
        case '+': case '=': zoomBy(0.4); break;
        case '-':           zoomBy(-0.4); break;
        case '0':           resetZoom(true); break;
      }
    }
  }

  // ─── Collect images from PDP gallery & attach triggers ───────────────────────
  function initGallery() {
    const mainImageEl = document.querySelector('[data-ds-main-image]');
    if (!mainImageEl) return;

    if (!mainImageEl.querySelector('[data-ds-image-slide]')) return;

    // Collected fresh on every open: the gallery is rebuilt when a variant has its own photo set,
    // and video slides are skipped (they play inline and have no image to zoom).
    function collectImages() {
      const indexMap = {};
      images = [];
      mainImageEl.querySelectorAll('img[data-ds-image-slide]').forEach(el => {
        indexMap[el.dataset.index] = images.length;
        images.push({
          src:     el.src,
          srcset:  el.srcset || '',
          alt:     el.alt || '',
          thumb:   el.src,
          // Build highest-res URL (swap width param to 2000)
          fullSrc: (el.srcset || el.src).split(',').pop().trim().split(' ')[0] || el.src,
        });
      });
      return indexMap;
    }

    function openFromActiveSlide() {
      const indexMap = collectImages();
      if (!images.length) return;
      const activeSlide = mainImageEl.querySelector('[data-ds-image-slide].is-active');
      const idx = activeSlide && indexMap[activeSlide.dataset.index] !== undefined ? indexMap[activeSlide.dataset.index] : 0;
      window.dsLightboxOpen(idx);
    }

    buildLightbox();

    // Add zoom-trigger button overlay
    const trigger = document.createElement('button');
    trigger.className = 'ds-pdp__zoom-trigger';
    trigger.setAttribute('aria-label', 'Open image viewer');
    trigger.setAttribute('type', 'button');
    trigger.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
        <circle cx="11" cy="11" r="8"/>
        <path d="M21 21l-4.35-4.35"/>
        <path d="M11 8v6M8 11h6"/>
      </svg>
      Zoom
    `;
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      openFromActiveSlide();
    });
    mainImageEl.appendChild(trigger);

    // Clicking main image also opens lightbox
    mainImageEl.addEventListener('click', (e) => {
      if (e.target.closest('.ds-pdp__zoom-trigger')) return;
      if (e.target.closest('video, iframe, .ds-pdp__ext-video-wrap')) return;
      const activeSlide = mainImageEl.querySelector('[data-ds-image-slide].is-active');
      if (activeSlide && activeSlide.tagName !== 'IMG') return;
      openFromActiveSlide();
    });

    // Sync lightbox index when user changes active slide via thumbs
    document.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-ds-thumb]');
      if (thumb) {
        const idx = parseInt(thumb.dataset.index, 10);
        if (!isNaN(idx)) currentIdx = idx;
      }
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

})();
